import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ClientRedirect,
  IClientRedirectProps,
} from '@components/ClientRedirect';

import { accessoriesMessages } from '../messages';
import { OtherVariantsWrapper } from '../styled';

interface ShowOtherVariantsLinkProps {
  product: IClientRedirectProps['product'];
}

export const ShowOtherVariantsLink: React.FC<ShowOtherVariantsLinkProps> = ({
  product,
}) => {
  return (
    <ClientRedirect useMasterUrl={true} product={product}>
      <OtherVariantsWrapper>
        <FormattedMessage
          {...accessoriesMessages.accessoriesShowOtherVariants}
        />
      </OtherVariantsWrapper>
    </ClientRedirect>
  );
};
